(function () {
  function initNiceTimesSlider(section) {
    if (!section || !section?.classList.contains("section-blog-posts")) {
      return;
    }
    const slider = section.querySelector(".blog-posts__slider--nice-times");
    if (!slider || slider.swiper || typeof Swiper === "undefined") {
      return;
    }
    const nextBtn = section.querySelector(".blog-posts__nav-button--next");
    const prevBtn = section.querySelector(".blog-posts__nav-button--prev");
    new Swiper(slider, {
      slidesPerView: 1.08,
      spaceBetween: 16,
      speed: 800,
      allowTouchMove: true,
      watchOverflow: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
      },
      breakpoints: {
        576: {
          slidesPerView: 2.15,
          spaceBetween: 20,
        },
        990: {
          slidesPerView: 3.15,
          spaceBetween: 24,
        },
        1360: {
          slidesPerView: 4.15,
          spaceBetween: 24,
        },
      },
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
    });
  }

  function updateLabelWrappers() {
    const labels = document.querySelectorAll(".article-card-label-text");
    labels.forEach((label) => {
      const labelWidth = label.offsetWidth + 40;
      const wrapper = label.closest(".article-card-label-wrapper");
      if (wrapper) {
        wrapper.style.width = `${labelWidth}px`;
      }
    });
  }
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("section-blog-posts")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  updateLabelWrappers();
  initHeadingAnimation(document.currentScript.parentElement);
  initNiceTimesSlider(document.currentScript.parentElement);
  document.addEventListener("DOMContentLoaded", () => {
    updateLabelWrappers();
    initNiceTimesSlider(document.currentScript.parentElement);
  });
  window.addEventListener("resize", updateLabelWrappers);
  document.addEventListener("shopify:section:load", (e) => {
    updateLabelWrappers();
    initHeadingAnimation(e.target);
    initNiceTimesSlider(e.target);
  });
})();
